import type { IconProps } from '@/components/icons'

interface EmptyStateProps {
  icon: React.ComponentType<IconProps>
  title: string
  description?: string
}

export function EmptyState({ icon: Icon, title, description }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-gray-500">
      <Icon className="mb-4 h-16 w-16" />
      <p className="text-lg font-medium">{title}</p>
      {description && <p className="mt-1 text-sm">{description}</p>}
    </div>
  )
}
